<template>
  <!-- name: '我要捐-我的捐赠' -->
  <div class="myDonateWrap">
    <SelectTab
      :selectTabList="selectTabList"
      :curSelectTab="curSelectTab"
      @selectTab="selectTab"
    />
    <div class="labelBox">
      <span
        v-for="(item, index) in labelList"
        :key="index"
        :class="item.value === status ? 'actClass' : ''"
        @click="
          status = item.value;
          getMyDonateList();
        "
        >{{ item.text }}</span
      >
    </div>
    <van-loading v-if="isShowLoading">加载中...</van-loading>
    <div class="dataListBox" v-show="!isShowLoading">
      <div v-if="curSelectTab === '捐衣'">
        <ul v-show="clothesList.length > 0">
          <li v-for="(item, index) in clothesList" :key="index">
            <input
              type="checkBox"
              :checked="item.isCheck"
              @click="handleCheck(item)"
              v-show="status === 1 || status === 2"
            />
            <div class="contentBox">
              <div
                class="topClass"
                @click="
                  $router.push({
                    path: '/donateThird',
                    query: {
                      title: '捐赠详情',
                      number: item.code,
                      nextPath: '/donateSecond',
                      status: item.status,
                      donateType: item.type
                    },
                  })
                "
              >
                <span class="tagClass">捐赠编号</span>
                <span class="numberClass">{{ item.code }}</span>
                <img src="https://img.bbalt.cn/imgh5/icon_arrow.svg" alt="" />
                <span
                  :class="
                    status === 3 || status === 4
                      ? 'grayClass statusClass'
                      : 'statusClass'
                  "
                  >{{ item.statusLabel }}</span
                >
              </div>
              <div class="infoBox">
                <div class="itemClass">
                  捐赠日期
                  <span>{{ item.donateDate }}</span>
                </div>
                <div class="itemClass">
                  涉及项目数
                  <span>{{ item.demandCount ? item.demandCount : 0 }}</span>
                </div>
                <div class="itemClass">
                  捐赠件数
                  <span>{{ item.pledgedCount ? item.pledgedCount : 0 }}</span>
                </div>
              </div>
              <div class="buttonBox">
                <button
                  class="editButton"
                  v-show="status === 1 || status === 2"
                  @click="
                    curObj = item;
                    handleEditExpress()
                  "
                >
                  修改邮寄方式
                </button>
                <button
                  class="cancelButton"
                  v-show="status === 1 || status === 2"
                  @click="
                    showPoint = true;
                    curObj = item;
                  "
                >
                  取消捐赠
                </button>
                <button
                  v-if="1 == 2"
                  class="certButton"
                  v-show="status === 4"
                  @click="
                    $router.push({
                      path: '/other',
                      query: { title: '捐衣海报' },
                    })
                  "
                >
                  查看证书
                </button>
              </div>
            </div>
          </li>
        </ul>
        <div class="noDataBox" v-show="clothesList.length === 0">
          <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
          暂无数据
        </div>
      </div>

      <div v-else>
        <ul v-show="goodsList.length > 0">
          <li v-for="(item, index) in goodsList" :key="index">
            <input
              type="checkBox"
              :checked="item.isCheck"
              @click="handleCheck(item)"
            />
            <div class="contentBox">
              <div
                class="topClass"
                @click="
                  $router.push({
                    path: '/donateThird',
                    query: {
                      title: '捐赠详情',
                      number: item.code,
                      nextPath: '/donateSecond',
                      status: item.status,
                      donateType: item.type
                    },
                  })
                "
              >
                <span class="tagClass">捐赠编号</span>
                <span class="numberClass">{{ item.code }}</span>
                <img src="https://img.bbalt.cn/imgh5/icon_arrow.svg" alt="" />
                <span
                  :class="
                    status === 3 || status === 4
                      ? 'grayClass statusClass'
                      : 'statusClass'
                  "
                  >{{ item.statusLabel }}</span
                >
              </div>
              <div class="infoBox">
                <div class="itemClass">
                  捐赠日期
                  <span>{{ item.donateDate }}</span>
                </div>
                <div class="itemClass">
                  涉及项目数
                  <span>{{ item.demandCount ? item.demandCount : 0 }}</span>
                </div>
                <div class="itemClass">
                  捐赠件数
                  <span>{{ item.pledgedCount ? item.pledgedCount : 0 }}</span>
                </div>
              </div>
              <div class="buttonBox">
                <button
                  class="cancelButton"
                  v-show="status === 1 || status === 2"
                  @click="
                    showPoint = true;
                    curObj = item;
                  "
                >
                  取消捐赠
                </button>
                <button
                  v-if="1 == 2"
                  class="certButton"
                  v-show="status === 4"
                  @click="
                    $router.push({
                      path: '/other',
                      query: { title: '捐衣海报' },
                    })
                  "
                >
                  查看证书
                </button>
              </div>
            </div>
          </li>
        </ul>
        <div class="noDataBox" v-show="goodsList.length === 0">
          <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
          暂无数据
        </div>
      </div>
      <van-loading v-if="isLazyLoad" />
    </div>
    <div
      class="footBox"
      v-if="curSelectTab === '捐衣'"
      v-show="status === 1 && clothesList.length > 0"
    >
      <div class="btnListBox">
        <span></span>
      </div>
      <button v-show="status === 1 && clothesList.length > 0" class="buttonClass" @click="handleDeliver">
        去发货
      </button>
      <button
        v-show="status === 2 && clothesList.length > 0"
        class="buttonClass"
        @click="handlLookNumber"
      >
        填写物流单号
      </button>
    </div>
    <div class="footBox" v-else v-show="status === 1 && goodsList.length > 0">
      <div class="btnListBox">
        <span
          ></span
        >
      </div>
      <button v-show="status === 1 && goodsList.length > 0" class="buttonClass" @click="handleDeliver">
        去发货
      </button>
      <button
        v-show="status === 2 && goodsList.length > 0"
        class="buttonClass"
        @click="handlLookNumber"
      >
        填写物流单号
      </button>
    </div>
    <van-dialog
      v-model="showPoint"
      confirmButtonColor="#00a392"
      :showCancelButton="true"
      confirmButtonText="确认"
      cancelButtonText="取消"
      @confirm="
        handleCancelDonate();
        showPoint = true;
      "
    >
      <p>你确定要取消捐赠吗？</p>
    </van-dialog>
    <!--修改邮寄方式弹窗-->
    <van-dialog
      v-model="showEditExpress"
      :showCancelButton="true"
      confirmButtonText="确认"
      cancelButtonText="取消"
      title="修改邮寄方式"
      @confirm="
        saveExpressInfo()
      "
    >
      <van-form>
        <van-cell-group inset>
          <van-field
            name="way"
            label="邮寄方式">
           <template #input>
              <van-radio-group v-model="way" direction="horizontal" @change="expressRadioChange">
                <van-radio name="1">快递</van-radio>
                <van-radio name="2">送货上门</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
           v-if="way == 1"
            v-model="expressNo"
            name="expressNo"
            label="快递单号"
            placeholder="请填写快递单号"
            :rules="[{ required: true, message: '请填写快递单号' }]"
          />
        </van-cell-group>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import SelectTab from "@/components/SelectTab";
import { myDonateList, cancelDonate, getExpressInfoApi, changeExpressInfoApi } from "@/api/donate.js";
import mixin from "@/utils/mixin.js";
export default {
  mixins: [mixin],
  components: { SelectTab },
  data() {
    return {
      selectTabList: ["捐衣", "捐物"],
      curSelectTab: "捐衣",
      labelList: [
        {
          text: "待发货",
          value: 1,
        },
        {
          text: "捐赠中",
          value: 2,
        },
        {
          text: "已失效",
          value: 3,
        },
        {
          text: "已完成",
          value: 4,
        },
      ],
      status: 1,
      dataList: [],
      isAllClothesCheck: false,
      isAllGoodsCheck: false,
      listQuery: { pageNo: 1, pageSize: 10 },
      clothesList: [],
      goodsList: [],
      isShowLoading: true,
      isLazyLoad: false,
      showPoint: false,
      curObj: {},
      curDataList: [],
      selectDonateInfoId: '',
      showEditExpress: false,
      way: '',
      expressNo: '',
      expressNoList: []
    };
  },
  created() {
    this.isShowLoading = true;
    this.status = this.$route.query.status
      ? Number(this.$route.query.status)
      : 1;
    this.curSelectTab = this.$route.query.curSelectTab ? this.$route.query.curSelectTab : localStorage.getItem("curSelectTab");
    this.getMyDonateList();
  },
  methods: {
    handleDeliver() {
      const codeList = [];
      if (this.curSelectTab === "捐衣") {
        this.clothesList.map((item) => {
          if (item.isCheck) {
            codeList.push(item.code);
            this.selectDonateInfoId = item.id
          }
        });
        if (codeList.length === 0) {
          this.$toast("请选择要发货的衣物");
          return;
        } else {
          this.$router.push({
            path: "/send",
            query: {
              curStep: `${
                localStorage.getItem("curSelectTab") === "捐衣"
                  ? "衣物"
                  : "物品"
              }发货`,
              curStepIndex: 2,
              code: codeList.join(","),
              donateType: 1,
              donateInfoId: this.selectDonateInfoId
            },
          });
        }
      } else {
        this.goodsList.map((item) => {
          if (item.isCheck) {
            codeList.push(item.code);
            this.selectDonateInfoId = item.id
          }
        });
        if (codeList.length === 0) {
          this.$toast("请选择要发货的衣物");
          return;
        } else {
          this.$router.push({
            path: "/send",
            query: {
              curStep: "捐衣发货",
              curStepIndex: 2,
              code: codeList.join(","),
              donateType: 2,
              donateInfoId: this.selectDonateInfoId
            },
          });
        }
      }
    },
    handlLookNumber() {
      const codeList = [];
      if (this.curSelectTab === "捐衣") {
        this.clothesList.map((item) => {
          if (item.isCheck) {
            codeList.push(item.code);
            this.selectDonateInfoId = item.id
          }
        });
      } else {
        this.goodsList.map((item) => {
          if (item.isCheck) {
            codeList.push(item.code);
          }
        });
      }
      if (codeList.length === 0) {
        this.$toast("请选择要发货的衣物");
        return;
      } else {
        this.$router.push({
          path: "/send",
          query: {
            curStep: "物流信息",
            curStepIndex: 3,
            code: codeList.join(","),
            curName: this.curSelectTab,
            donateType: this.curSelectTab === '捐衣' ? 1 : 2,
            donateInfoId: this.selectDonateInfoId
          },
        });
      }
    },
    async getMyDonateList(pageNo, isLazy) {
      if (isLazy) {
        this.isLazyLoad = true;
      }
      this.listQuery.pageNo = pageNo > 1 ? pageNo : this.listQuery.pageNo;
      if (this.curSelectTab === "捐衣") {
        const { content } = await myDonateList({
          ...{ type: 1, status: this.status },
          ...this.listQuery,
        });
        this.clothesList = isLazy
          ? [...this.curDataList, ...content.records]
          : content.records;
        this.total = content.total;
        this.isShowLoading = false;
        this.isLazyLoad = false;
      }
      if (this.curSelectTab === "捐物") {
        const { content } = await myDonateList({
          ...{ type: 2, status: this.status },
          ...this.listQuery,
        });
        this.goodsList = isLazy
          ? [...this.curDataList, ...content.records]
          : content.records;
        this.total = content.total;
        this.isShowLoading = false;
        this.isLazyLoad = false;
      }
    },
    selectTab(item) {
      this.isShowLoading = true;
      this.curSelectTab = item;
      this.listQuery = { pageNo: 1, pageSize: 10 };
      this.getMyDonateList();
      localStorage.setItem("curSelectTab", item);
    },
    setAllCheck() {
      if (this.curSelectTab === "捐衣") {
        this.isAllClothesCheck = !this.isAllClothesCheck;
        this.clothesList.map((item) => {
          item.isCheck = this.isAllClothesCheck;
          return item;
        });
      }
      if (this.curSelectTab === "捐物") {
        this.isAllGoodsCheck = !this.isAllGoodsCheck;
        this.goodsList.map((item) => {
          item.isCheck = this.isAllGoodsCheck;
          return item;
        });
      }
    },
    async handleCancelDonate() {
      const { code, message } = await cancelDonate(this.curObj);
      if (code == 200) {
        this.$toast.success("已取消捐赠");
        this.listQuery = { pageNo: 1, pageSize: 10 };
        this.getMyDonateList();
      } else {
        this.$toast.fail(message);
      }
    },

    async handleEditExpress() {
      // 查询当前邮寄方式
      const params = {donateInfoId : this.curObj.id}
      const { code, message, content} = await getExpressInfoApi(params)
      if (code === 200) {
        this.showEditExpress = true
        this.way = content.way + ''
        this.expressNo = content.expressNo[0]
      } else {
        this.$toast.fail(message)
      }
    },

    handlePopState() {
      if (Boolean(this.$route.query.id)) {
        this.$router
          .push({
            path: "/donateThird",
            query: {
              title: "项目详情",
              id: this.$route.query.id,
              nextPath: "/home",
            },
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },
    handleCheck(item) {
      console.log(item.id)
      // 其他的修改为非选中，当前的修改为选中
      if (this.curSelectTab === '捐衣') {
        this.clothesList.forEach(data => {
          if (data.id == item.id) {
            data.isCheck = !data.isCheck
          } else {
            data.isCheck = false
          }
        });
        console.log(this.clothesList)
      } else {
        this.goodsList.forEach(data => {
          if (data.id == item.id) {
            data.isCheck = !data.isCheck
          } else {
            data.isCheck = false
          }
        })
      }
    },
    expressRadioChange(val) {
      if (val == 1) {
        this.expressNo = ''
      }
    },
    async saveExpressInfo() {
      const expressNo = (this.expressNo || "").trim();
      if (String(this.way) === "1" && !expressNo) {
        this.$toast.fail("请填写快递单号");
        return;
      }
      const data = {
        donateInfoId: this.curObj.id,
        way: Number(this.way),
        expressNo: expressNo ? [expressNo] : [],
      };
      const { code, message } = await changeExpressInfoApi(data);
      if (code !== 200) {
        this.$toast.fail(message);
      } else {
        this.$toast.success("修改成功");
        this.showEditExpress = false;
        this.listQuery.pageNo = 1;
        this.getMyDonateList();
      }
    }
  },
  mounted() {
    let dom = document.querySelector(".dataListBox");
    this.handleScrollLazy(
      dom,
      this.listQuery.pageNo,
      this.listQuery.pageSize,
      this.total,
      this.getMyDonateList
    );
    let that = this;
    window.addEventListener("popstate", that.handlePopState, false);
  },
  beforeDestroy() {
    let that = this;
    window.removeEventListener("popstate", that.handlePopState(), false);
  },
};
</script>

<style lang="scss" scoped>
.myDonateWrap {
  height: 100vh;
  margin-top: 96px;
  font-family: PingFangSC, PingFang SC;
  overflow: hidden;

  ::v-deep .selectTabBox {
    justify-content: space-around;

    .lineBox {
      margin-top: -10px !important;
    }
  }

  .labelBox {
    width: calc(100% - 64px);
    height: 56px;
    margin: 32px 32px;
    display: flex;
    justify-content: space-between;

    span {
      font-size: 28px;
      font-weight: 400;
      color: #999999;
      width: 152px;
      height: 56px;
      text-align: center;
      line-height: 56px;
      background: #eeeeee;
      border-radius: 28px;
      border: 1px solid #dddddd;

      &.actClass {
        color: #fff;
        background: #fe66a6;
        border: none;
      }
    }
  }

  .dataListBox {
    width: 100%;
    overflow: auto;
    padding-bottom: 150px;
    max-height: 72%;

    ul {
      width: 100%;
      padding: 0px 32px;

      li {
        width: 100%;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        padding: 35px 24px 24px 24px;

        input {
          width: 50px;
          margin-right: 14px;
        }

        .contentBox {
          display: flex;
          flex-flow: column;
          justify-content: space-between;
          width: 90%;

          .topClass {
            margin-bottom: 32px;
            display: flex;
            align-items: center;

            .tagClass {
              border: 1px solid #fe66a6;
              font-size: 22px;
              font-weight: 400;
              color: #fe66a6;
              margin-right: 16px;
              background: rgba(254, 102, 166, 0.08);
              border-radius: 4px;
              display: inline-block;
              text-align: center;
              padding: 5px;
              width: auto;
              white-space: nowrap;
            }

            .numberClass {
              font-size: 36px;
              font-weight: 600;
              color: #333333;
              margin-right: 4px;
            }

            img {
              width: 30px;
              height: 30px;
            }

            .statusClass {
              width: 152px;
              text-align: right;
              display: inline-block;
              font-size: 28px;
              font-weight: 400;
              color: #fe66a6;

              &.grayClass {
                color: #999999;
              }
            }
          }

          .infoBox {
            display: flex;
            justify-content: space-between;
            margin-bottom: 28px;

            .itemClass {
              display: flex;
              flex-flow: column;
              font-size: 26px;
              font-weight: 400;
              color: #666666;

              span {
                font-size: 28px;
                color: #333333;
                margin-top: 8px;
                text-align: center;
              }
            }
          }

          .buttonBox {
            width: 100%;
            display: flex;
            justify-content: flex-end;

            button {
              width: 180px;
              height: 56px;
              border-radius: 28px;
              font-size: 28px;
              font-weight: 400;
            }

            .editButton {
              background: #eeeeee;
              border: 1px solid #dddddd;
              color: #333333;
              margin-right: 5px;
            }
            .cancelButton {
              background: #eeeeee;
              border: 1px solid #dddddd;
              color: #333333;
            }

            .certButton {
              background: #fe66a6;
              border-radius: 28px;
              color: #ffffff;
              border: none;
            }
          }
        }
      }
    }
  }

  .footBox {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 220px;
    background: #ffffff;
    box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
    border-radius: 0px 0px 16px 16px;
    display: flex;
    justify-content: space-between;

    .buttonClass {
      width: 304px;
      height: 88px;
      background: #fe66a6;
      box-shadow: 0px -1px 16px 0px rgba(0, 0, 0, 0.08);
      border-radius: 47px;
      border: none;
      font-size: 32px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 88px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-top: 16px;
      margin-right: 32px;
    }

    .btnListBox {
      display: flex;
      font-size: 28px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #333333;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      margin-left: 64px;
      height: 80px;
      margin-top: 16px;

      input {
        margin-right: 24px;
      }

      span {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

.noDataBox {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  img {
    width: 80%;
    margin: 30px auto;
  }
}

.van-loading {
  text-align: center;
}

.van-dialog p {
  margin-top: 30px;
  padding: 20px;
  line-height: 40px;
  text-align: center;
}

::v-deep .van-dialog__header {
  color: #000;
}
</style>
